export default "__VITE_ASSET__Bk_6qWZM__"